export default __webpack_public_path__ + "medical-kit.png";